import { useState } from 'react';
import { Link } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import Lightbox from '../components/Lightbox';
import NoteCard from '../components/NoteCard';
import NotesTabs from '../components/NotesTabs';
import { useAuth } from '../lib/auth';
import { filterIdeas, useIdeas } from '../lib/useIdeas';

export default function Notes() {
  const { user } = useAuth();
  const { ideas, error, loading } = useIdeas(user?.uid);
  const [search, setSearch] = useState('');
  const [viewing, setViewing] = useState<{ images: string[]; start: number } | null>(null);

  const shown = filterIdeas(ideas, search);

  return (
    <>
      <AppHeader>
        <input
          className="search"
          type="search"
          placeholder="Search your ideas"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Link className="button primary" to="/new">New text note</Link>
        {/* Present but inert, so the web offers the same two ways in as the phones and says
            plainly which one it lacks. aria-disabled rather than disabled: a disabled button
            takes no focus and, in some browsers, no hover — the explanation would be
            unreachable for exactly the people trying to use it. */}
        <span className="has-tooltip">
          <button
            type="button"
            aria-disabled="true"
            aria-describedby="audio-note-tooltip"
          >
            New audio note
          </button>
          <span role="tooltip" id="audio-note-tooltip" className="tooltip">
            Audio note creation is not yet available on desktop. Record one in the iOS or
            Android app.
          </span>
        </span>
      </AppHeader>

      <main>
        <NotesTabs />
        {loading && <p className="muted">Loading…</p>}
        {error && <p className="error">{error}</p>}

        {!loading && !error && shown.length === 0 && (
          <p className="muted">
            {ideas.length === 0
              ? 'No ideas yet. Create one here, or capture one in the app, and it will appear here.'
              : `Nothing matches “${search}”.`}
          </p>
        )}

        <ul className="ideas">
          {shown.map((idea) => (
            <NoteCard
              key={idea.id}
              to={`/idea/${idea.id}`}
              title={idea.title}
              description={idea.description}
              images={idea.images}
              tags={idea.tags}
              date={idea.createdAt}
              links={idea.links}
              onViewImage={(images, start) => setViewing({ images, start })}
            />
          ))}
        </ul>
      </main>

      {viewing && (
        <Lightbox
          images={viewing.images}
          start={viewing.start}
          onClose={() => setViewing(null)}
        />
      )}
    </>
  );
}
